import { takeLatest, put } from 'redux-saga/effects';
import {
    ADD_TO_CART,
    ASK_USER_CURRENT_LOCATION,
    CANCEL_ORDER_OCP,
    CHECKOUT_SIGN_IN,
    CREATE_ACCOUNT,
    FAVORITES_UPDATED,
    GET_ACCESS_TOKEN,
    GET_APP_FAV_STORE,
    GET_BLACK_BOX_ID,
    GET_REFRESH_TOKEN,
    ORDER_PLACED,
    PATCH_HEADER,
    SIGN_IN,
    UPDATE_CART_COUNT,
    GET_USER_EMAIL_ID,
    GET_APP_GIFT_CARDS,
    UPDATE_APPLIED_GC_TO_APP,
    WEB_APP_ACCOUNT_LOCKED,
    APP_UNDO_ACTION,
    WEB_GET_APP_GC_BALANCE,
    WEB_CREATE_ACCOUNT_SLIDER_REQUEST,
    WEB_OPEN_QUICK_SCREEN,
    WEB_GET_REWARD_PROFILE,
    WEB_SYPI_WIDGET_REQUEST,
} from '../actionTypes/NativeAppActionTypes';
import ClientLoggerAction from '../actions/ClientLoggerAction';

/**
 * Triggers jcpWebApp Interface to post message to android / ios
 * @param {object} data
 */
function postMessageToApp(data) {
    window.jcpWebApp.postMessageToApp(data);
}
/**
 * @param {string} action name of the event
 * @param {object} payload data to be emitted
 * @param {string} returnAction name of the action web waits for from app
 */
function getMessageObject(action, data = {}, returnAction = '') {
    return {
        action,
        data,
        returnAction,
    };
}

/**
 * This is a basic pub sub event emitter
 */
function* generateBasicEventEmitter(action) {
    try {
        const { type, payload: { listenerType, data } = {} } = action;
        postMessageToApp(getMessageObject(type, data, listenerType));
    } catch (error) {
        const { type } = action;
        // eslint-disable-next-line no-console
        console.warn('Failed to generate event to app ', error);
        yield put(
            ClientLoggerAction.logError(
                `WEBVIEW::ERROR - Failed to generate event to app, type-${type}`,
                error
            )
        );
    }
}

const nativeAppSaga = function* nativeAppSaga() {
    const watchList = [
        ADD_TO_CART,
        ASK_USER_CURRENT_LOCATION,
        CANCEL_ORDER_OCP,
        CHECKOUT_SIGN_IN,
        CREATE_ACCOUNT,
        FAVORITES_UPDATED,
        GET_ACCESS_TOKEN,
        GET_APP_FAV_STORE,
        GET_BLACK_BOX_ID,
        GET_REFRESH_TOKEN,
        ORDER_PLACED,
        PATCH_HEADER,
        SIGN_IN,
        UPDATE_CART_COUNT,
        GET_USER_EMAIL_ID,
        GET_APP_GIFT_CARDS,
        UPDATE_APPLIED_GC_TO_APP,
        WEB_APP_ACCOUNT_LOCKED,
        APP_UNDO_ACTION,
        WEB_GET_APP_GC_BALANCE,
        WEB_CREATE_ACCOUNT_SLIDER_REQUEST,
        WEB_OPEN_QUICK_SCREEN,
        WEB_GET_REWARD_PROFILE,
        WEB_SYPI_WIDGET_REQUEST,
    ];
    yield takeLatest(watchList, generateBasicEventEmitter);
};

nativeAppSaga.sagaName = 'nativeAppSaga';

export default nativeAppSaga;
